export default {"src":"/_next/static/media/antecipame-logo.8127c5ba.svg","height":52,"width":253,"blurWidth":0,"blurHeight":0};